/** Renderer-only identity profiles. Combat remains entirely in the fixed-tick simulation. */
export type WeaponFxStyle = 'rocket' | 'cruise' | 'howitzer' | 'mortar' | 'tesla' | 'gatling' | 'nulificator' | 'aa' | 'goo' | 'chain' | 'gauss' | 'oil' | 'missile' | 'orbital' | 'generic';

export interface WeaponFxProfile {
  style: WeaponFxStyle;
  fireLifetime: number;
  impactLifetime: number;
}

const GENERIC: WeaponFxProfile = { style: 'generic', fireLifetime: 90, impactLifetime: 180 };

export const WEAPON_FX: Readonly<Record<string, WeaponFxProfile>> = {
  rocket: { style: 'rocket', fireLifetime: 115, impactLifetime: 210 },
  cruiseMissile: { style: 'cruise', fireLifetime: 210, impactLifetime: 360 },
  ball: { style: 'howitzer', fireLifetime: 190, impactLifetime: 340 },
  mortarShell: { style: 'mortar', fireLifetime: 230, impactLifetime: 380 },
  electricField: { style: 'tesla', fireLifetime: 180, impactLifetime: 230 },
  laserBeam: { style: 'gatling', fireLifetime: 95, impactLifetime: 130 },
  nulifyBall: { style: 'nulificator', fireLifetime: 180, impactLifetime: 250 },
  aaShell: { style: 'aa', fireLifetime: 105, impactLifetime: 160 },
  slowShot: { style: 'goo', fireLifetime: 150, impactLifetime: 260 },
  chainBlast: { style: 'chain', fireLifetime: 160, impactLifetime: 200 },
  gaussRail: { style: 'gauss', fireLifetime: 210, impactLifetime: 180 },
  orbitalStrike: { style: 'orbital', fireLifetime: 320, impactLifetime: 320 },
  orbitalGround: { style: 'orbital', fireLifetime: 240, impactLifetime: 420 },
  confuseBall: { style: 'oil', fireLifetime: 155, impactLifetime: 240 },
  missile: { style: 'missile', fireLifetime: 180, impactLifetime: 420 },
};

export const weaponFxFor = (projectileKind?: string): WeaponFxProfile => WEAPON_FX[projectileKind ?? ''] ?? GENERIC;
